import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-305b3a85")

_pushScopeId("data-v-305b3a85")
const _hoisted_1 = { class: "flex align-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 从Pexels选择 ")
const _hoisted_3 = { class: "flex align-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 从Pexels选择 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_tag_input = _resolveComponent("tag-input")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_mind_up_options_input = _resolveComponent("mind-up-options-input")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_button = _resolveComponent("el-button")
  const _component_image_uploader = _resolveComponent("image-uploader")
  const _component_el_form = _resolveComponent("el-form")
  const _component_image_picker = _resolveComponent("image-picker")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      ref: "form",
      model: _ctx.formData,
      "label-width": "80px"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          prop: "name",
          rules: [{ required: true,message: '请输入名称',trigger: 'blur' }],
          label: "名称"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "matchTags",
          label: "匹配标签"
        }, {
          default: _withId(() => [
            _createVNode(_component_tag_input, {
              allowAddNewTag: false,
              modelValue: _ctx.formData.matchTags,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.matchTags = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "sortNumber",
          label: "排序"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.formData.sortNumber,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.sortNumber = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "options",
          label: "可选项"
        }, {
          default: _withId(() => [
            _createVNode(_component_mind_up_options_input, {
              modelValue: _ctx.formData.options,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.options = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "lightBackground",
          rules: [{ required: true,message: '请上传浅色背景',trigger: 'blur' }],
          label: "浅色背景"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_1, [
              (_ctx.formData.lightBackground)
                ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 0,
                    class: "icon",
                    src: _ctx.formData.lightBackground
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              (!_ctx.showLightBackgroundUploading)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    class: "margin-left-10",
                    type: "info",
                    i: "el-icon-plus",
                    onClick: _ctx.selectForLightBackground
                  }, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_image_uploader, { onSuccess: _ctx.handleLightBackgroundUploaded }, null, 8, ["onSuccess"]),
              _createVNode(_component_el_input, {
                class: "w-0",
                type: "hidden",
                modelValue: _ctx.formData.lightBackground,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.lightBackground = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "darkBackground",
          rules: [{ required: true,message: '请上传深色背景',trigger: 'blur' }],
          label: "深色背景"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_3, [
              (_ctx.formData.darkBackground)
                ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 0,
                    class: "icon",
                    src: _ctx.formData.darkBackground
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              (!_ctx.showDarkBackgroundUploading)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    class: "margin-left-10",
                    type: "info",
                    i: "el-icon-plus",
                    onClick: _ctx.selectForDarkBackground
                  }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_image_uploader, { onSuccess: _ctx.handleDarkBackgroundUploaded }, null, 8, ["onSuccess"]),
              _createVNode(_component_el_input, {
                class: "w-0",
                type: "hidden",
                modelValue: _ctx.formData.darkBackground,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.darkBackground = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { class: "flex-center" }, {
          default: _withId(() => [
            _createVNode(_component_el_button, {
              class: "margin-right-10",
              type: "primary",
              onClick: _ctx.submit
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_el_dialog, {
      title: "选图",
      top: "10px",
      modelValue: _ctx.imageDialogVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.imageDialogVisible = $event)),
      width: "80%"
    }, {
      default: _withId(() => [
        _createVNode(_component_image_picker, {
          singleMode: true,
          onSelected: _ctx.handleImageSelected
        }, null, 8, ["onSelected"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})